import {ROLE_FIELD_MANAGER} from 'shared/constant/lookup/role'
import useRoleCookie from 'shared/model/useRoleCookie'
import DefaultButton from '../DefaultButton'
import Style from './style'

const EventInfor = ({
	level = 'N/A',
	time = '00:00',
	players = '0',
	entries = '0',
	reEntry = '0',
	early = '0',
	addOn = '0',
	avgStackBB = '0 (0.0)',
	totalStack = '0',
	isLoading = false,
	isWarning = false,
	isMobile = false,
	initEvent = () => {},
	setTimerSelect = () => {},
}) => {
	const [userRole] = useRoleCookie()
	const isFieldManager = userRole === ROLE_FIELD_MANAGER
	return (
		<Style.Wrapper>
			<Style.LevelTimeSection>
				<Style.LevelText>Level {isLoading ? '...' : level}</Style.LevelText>
				<Style.TimeContainer>
					<Style.TimeText $warning={isWarning}>
						{isLoading ? '...' : time}
					</Style.TimeText>
				</Style.TimeContainer>
			</Style.LevelTimeSection>

			<Style.InfoSection>
				<Style.InfoLabel>Players / Entries</Style.InfoLabel>
				<Style.InfoValue>
					{isLoading ? (
						'...'
					) : (
						<>
							{players} / {entries}
						</>
					)}
				</Style.InfoValue>
			</Style.InfoSection>

			<Style.InfoSection>
				<Style.InfoLabel>Re-Entry / Early / Add-on</Style.InfoLabel>
				<Style.InfoValue>
					{isLoading ? (
						'...'
					) : (
						<>
							{reEntry} / {early} / {addOn}
						</>
					)}
				</Style.InfoValue>
			</Style.InfoSection>

			<Style.InfoSection>
				<Style.InfoLabel>Avg Stacks (BB) / Total Stacks</Style.InfoLabel>
				<Style.InfoValue>
					{isLoading ? (
						'...'
					) : (
						<>
							{avgStackBB} / {totalStack}
						</>
					)}
				</Style.InfoValue>
			</Style.InfoSection>
			{!isFieldManager && (
				<Style.TableVerticalElement>
					<Style.Timer>타이머</Style.Timer>
					<Style.BtnDefaultContainer>
						<DefaultButton fitWidth small clickEvent={initEvent}>
							타이머 초기화
						</DefaultButton>
						<DefaultButton fitWidth small clickEvent={setTimerSelect}>
							타이머 특정 레벨로 이동
						</DefaultButton>
					</Style.BtnDefaultContainer>
				</Style.TableVerticalElement>
			)}
		</Style.Wrapper>
	)
}

export default EventInfor
